import { PartnerProfessionalPageQueryDocument, PartnerProfessionalResults } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export async function getPartnerProfessionals(
  id: string,
  page: number = 1,
): Promise<PartnerProfessionalResults | null | undefined> {
  const { data } = await ApolloClient.query({
    query: PartnerProfessionalPageQueryDocument,
    variables: { id, page },
  });

  return data?.partnerProfessionals;
}
